// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchBar_wrapper__vdXP-","desktop":"SearchBar_desktop__Bn4qj"};